export default __webpack_public_path__ + "static/media/mapPinClosedSelected.90eed3d0.svg";